import React from 'react';
import appConfig from '../../../../app-config';

const MenuArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="23"
      viewBox="0 0 46 23"
      style={{cursor: 'pointer'}}
    >
      <path
        className="arrowSvgPath"
        fill="none"
        fillRule="evenodd"
        stroke={appConfig.styleConfig.menuArrowStrokeColour}
        strokeLinecap="round"
        strokeWidth="2"
        d="M44.25 11.5L33.75 1m10.5 10.5L33.75 22M44 11.25H1"
      />
    </svg>
  );
};

export default MenuArrow;
